export const TOGGLE_PANEL_OPERATION = 'TOGGLE_PANEL_OPERATION';
export const TOGGLE_PANEL_ACTIONS = 'TOGGLE_PANEL_ACTIONS';
export const TOGGLE_PANEL_CURVES = 'TOGGLE_PANEL_CURVES';
export const TOGGLE_PANEL_CCENTER = 'TOGGLE_PANEL_CCENTER';
export const TOGGLE_PANEL_SIMULATOR = 'TOGGLE_PANEL_SIMULATOR';

interface TogglePanelOperation {
  type: typeof TOGGLE_PANEL_OPERATION;
  payload: { openPanelOperation: boolean };
}

interface TogglePanelActions {
  type: typeof TOGGLE_PANEL_ACTIONS;
  payload: { openPanelActions: boolean };
}
interface TogglePanelCurves {
  type: typeof TOGGLE_PANEL_CURVES;
  payload: { openPanelCurves: boolean };
}

interface TogglePanelCCenter {
  type: typeof TOGGLE_PANEL_CCENTER;
  payload: { openPanelCCenter: boolean };
}

interface TogglePanelSimulator {
  type: typeof TOGGLE_PANEL_SIMULATOR;
  payload: { openPanelSimulator: boolean };
}

export type ToolbarActions =
  | TogglePanelOperation
  | TogglePanelActions
  | TogglePanelCurves
  | TogglePanelCCenter
  | TogglePanelSimulator;
